<template>
    <div ref="soc-chart-container" class="soc-chart-box">
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: 'SocChart',
    methods: {
        getOption() {
            const option = {
                grid: {
                    top: 20,
                    left: 40,
                    bottom: 30,
                    right: 10
                },
                xAxis: {
                    type: 'category',
                    data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,15, 16, 17, 18, 19, 20],
                    axisLabel: {
                        color: '#E3F0FF',
                        fontSize: 12,
                        fontWeight: 700
                    },  
                    axisLine: {
                        lineStyle: {
                            color: '#0C89AD',
                            opacity: 0.3
                        }
                    },
                },
                yAxis: {
                    type: 'value',
                    name: '电池号',
                    nameLocation: 'start',
                    min: 68,
                    nameTextStyle: {
                        color: '#E3F0FF',
                        align: 'right'
                    }, 
                    axisLabel: {
                        color: '#E3F0FF',
                        fontSize: 12,
                        fontWeight: 700
                    }, 
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#0C89AD',
                            opacity: 0.3
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#094B85'],
                            opacity: 0.3
                        }
                    }
                },
                series: [{
                    name: '运行',
                    data: [70, 70, 71, 70, 70, 70, 72, 71, 71, 72, 72, 72, 72, 70, 70, 70, 71, 70, 71, 70],
                    type: 'bar',
                    itemStyle: {
                        color: 'rgba(45, 146, 255, .4)'
                    },
                    barWidth: 8
                }
               ]
            };
            return option;
        }
    },
    mounted() {
        const chartDom = this.$refs['soc-chart-container'];
        const myChart = echarts.init(chartDom);
        myChart.setOption(this.getOption());
    }
}
</script>

<style lang="less" scoped>
    .soc-chart-box {
        height: 100%;
        width: 100%;
    }
</style>